import React from "react";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const TermsAndConditionsDialog = (props) => {

  const {
    open,
    name,
    data,
    handleClose,
  } = props;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {`${getLocalizedString("requirementsAndConditions")}: ${name}`}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Grid container item xs={12}>
            <TextFieldMultiline
              disabled
              fullWidth
              label={getLocalizedString("requirementsAndConditions")}
              rows={5}
              margin={"none"}
              value={data}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction isAccept text={getLocalizedString("close")} onClick={handleClose} />
        </DialogActions>
      </div>
    </Dialog>
  );
}

export default TermsAndConditionsDialog;
